import { render, staticRenderFns } from "./LightboxProvider.vue?vue&type=template&id=34dc9768"
import script from "./LightboxProvider.vue?vue&type=script&lang=ts"
export * from "./LightboxProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports